import { Role } from "../models/role";

export class Helpers {
	/** Save current language in local storage */
	static setLanguage(userLang: string) {
		return localStorage.setItem('language', userLang);
	}

	/** Get current language */
	static getLanguage() {
		return localStorage.getItem('language') || navigator.language.substring(0, 2).toLowerCase();
	}

	/**
     * Get the current user from local storage, if it exists
     * @returns The current user
     */
    static getCurrentUser():any {
        const currentUser = JSON.parse(localStorage.getItem('currentUser')!); // Get current user
        if (currentUser) { // Check if user exists
            return currentUser;
        } else {
            return null;
        }
    }

    static role():Role {
        let role: string;
        let currentUser = JSON.parse(localStorage.getItem('Me')!);
        JSON.parse(localStorage.getItem('Me')!);
        return currentUser.role as Role;
    }

    static getMe():boolean{
        const me = JSON.parse(localStorage.getItem('Me')!);
        if(me){
            return true;
        }else{
            return false;
        }
    }

    static macCheck(mac: string): boolean {
        const regex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;
        return regex.test(mac);
    }

    static clearStorage(): void {
        localStorage.removeItem('currentUser');
    }

    static getToken(): string{
        let token: string;
        let currentUser = JSON.parse(localStorage.getItem('currentUser')!);
        JSON.parse(localStorage.getItem('currentUser')!);
        return token = currentUser.token;
    }

    static setLocationInLS(ls_name: string, ls_value: string, time: number, value_time: string ){
        const date = new Date();
		if (value_time === 'hours') {
			date.setTime(date.getTime() + time * 60 * 60 * 1000);
		} else if (value_time === 'days') {
			date.setTime(date.getTime() + time * 24 * 60 * 60 * 1000);
		} else if (value_time === 'minutes') {
			date.setTime(date.getTime() + time * 60 * 1000);
		} else {
			throw new Error('Invalid value_time. Use "hours" or "days".');
		}
		const expires = date.getTime();
        const obj = {
            "expires":expires,
            "locations":ls_value
        }
        localStorage.setItem(ls_name, JSON.stringify(obj));
    }

    static getLocationInLS(ls_name:string){
        if(localStorage.getItem(ls_name)){
            const obj = JSON.parse(localStorage.getItem(ls_name)!);
            const exipres = obj.expires;
            const date = new Date();
            if(exipres - date.getTime() > 0){
                return JSON.parse(obj.locations);
            }else{
                this.removeLocationInLS(ls_name);
                return null;
            }
        }else{
            return null;
        }
    }

    static removeLocationInLS(ls_name:string){
        localStorage.removeItem(ls_name);
    }

    static setCookie(cookie_name: string, cookie_value: string, time: number, value_time: string) {
		const date = new Date();
		if (value_time === 'hours') {
			date.setTime(date.getTime() + time * 60 * 60 * 1000);
		} else if (value_time === 'days') {
			date.setTime(date.getTime() + time * 24 * 60 * 60 * 1000);
		} else if (value_time === 'minutes') {
			date.setTime(date.getTime() + time * 60 * 1000);
		} else {
			throw new Error('Invalid value_time. Use "hours" or "days".');
		}
		const expires = `expires=${date.toUTCString()}`;
		document.cookie = `${cookie_name}=${cookie_value}; ${expires}; path=/`;
	}

    static getCookie(name: string): string {
		const cookieName = `${name}=`;
		const cookies = document.cookie.split(';');
		for (let i = 0; i < cookies.length; i++) {
			let cookie = cookies[i].trim();
			if (cookie.indexOf(cookieName) === 0) {
				return cookie.substring(cookieName.length, cookie.length);
			}
		}
		return "";
	}

	static removeCookie(cookie_name: string) {
		document.cookie = `${cookie_name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
	}

    static getTenant():string{
        const tenant = localStorage.getItem('tenant');
        if(!tenant){
            const currentUser = JSON.parse(localStorage.getItem('Me')!);
            return currentUser.tenants[0].name;
        }else{
            return tenant;
        }

    }

    static checkIp(ip: string) {
        // const myregex = /^(255|254|252|248|240|224|192|128|0)\.(255|254|252|248|240|224|192|128|0)\.(255|254|252|248|240|224|192|128|0)\.(255|254|252|248|240|224|192|128|0)$/;
        const myregex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        
        let resRegex = myregex.test(ip);
        if (resRegex) {
            return true;
        } else {
            return false;
        }
    }

}